import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import SearchInputField from '../SearchInputField';
import CoachSearch from '../CoachSearch';
import { InputTypes } from '../../utils/validateFormElement';

const CLICK_EVENT = 'click';

const HIDDEN_CLASS = 'u-hidden';

class CoachFinder extends FormComponent {
	constructor(element, config) {
		super(element, config);
	}
	markup(value, rowData, titleMarkup) {
		return `
            <div class="lta-coach-finder u-mb-5">
				<div class="lta-coach-finder-title u-hidden">${titleMarkup}</div>
                <div class="lta-coach-finder--search-input-wrapper">
					<div class="lta-coach-finder--search-input u-mb-2"></div>
					<div class="lta-coach-finder--search-form-button-wrapper u-flex">
						<button type="button" class="lta-coach-finder--search-form-button lta-btn lta-btn--lg lta-btn--link">Can’t find your coach? Enter manually</button>
					</div>
				</div>
				<div class="lta-coach-finder--search-result u-hidden"></div>
				<div class="lta-coach-finder--search-form u-hidden">
					<div class="lta-coach-finder--search-form-wrapper"></div>
					<div class="lta-coach-finder--search-form-button-wrapper u-flex">
						<button type="button" class="lta-coach-finder--address-form-button lta-btn lta-btn--lg lta-btn--link">Use coach look-up search</button>
					</div>
				</div>
            </div>
        `;
	}
	afterRender() {
		this.coachFinderElement = SelectorEngine.findOne('.lta-coach-finder', this.containerEl);
		this.coachFinderTitle = SelectorEngine.findOne('.lta-coach-finder-title', this.coachFinderElement);
		this.coachFinderSearchInputWrapper = SelectorEngine.findOne(
			'.lta-coach-finder--search-input-wrapper',
			this.coachFinderElement
		);
		this.coachFinderSearchInput = SelectorEngine.findOne(
			'.lta-coach-finder--search-input',
			this.coachFinderSearchInputWrapper
		);
		this.coachFinderSearchFormButton = SelectorEngine.findOne(
			'.lta-coach-finder--search-form-button',
			this.coachFinderSearchInputWrapper
		);
		this.coachFinderSearchResult = SelectorEngine.findOne('.lta-coach-finder--search-result', this.coachFinderElement);
		this.coachFinderSearchForm = SelectorEngine.findOne('.lta-coach-finder--search-form', this.coachFinderElement);
		this.coachFinderSearchFormWrapper = SelectorEngine.findOne(
			'.lta-coach-finder--search-form-wrapper',
			this.coachFinderSearchForm
		);
		this.coachFinderAddressButton = SelectorEngine.findOne(
			'.lta-coach-finder--address-form-button',
			this.coachFinderSearchForm
		);

		this.initSearchInputField();

		EventHandler.on(this.coachFinderSearchFormButton, CLICK_EVENT, () => {
			this.value = undefined;
			this.searchInputTextField.remove();
			this.coachFinderSearchInputWrapper.classList.add(HIDDEN_CLASS);
			this.coachFinderSearchResult.classList.add(HIDDEN_CLASS);
			this.coachFinderSearchForm.classList.remove(HIDDEN_CLASS);
			this.coachFinderTitle.classList.remove(HIDDEN_CLASS);

			this.coachSearch = new CoachSearch(this.coachFinderSearchFormWrapper, {
				data: this.data.coachFormElement
			});
			this.coachSearch.onChange((value) => {
				this.setupValueObject(value);
			});
		});

		EventHandler.on(this.coachFinderAddressButton, CLICK_EVENT, () => {
			this.value = undefined;
			this.coachSearch.remove();
			this.initSearchInputField();
			this.coachFinderSearchInputWrapper.classList.remove(HIDDEN_CLASS);
			this.coachFinderSearchResult.classList.add(HIDDEN_CLASS);
			this.coachFinderSearchForm.classList.add(HIDDEN_CLASS);
			this.coachFinderTitle.classList.add(HIDDEN_CLASS);
		});
	}
	initSearchInputField() {
		this.searchInputTextField = new SearchInputField(this.coachFinderSearchInput, {
			data: this.data
		});
		this.searchInputTextField.dataMapping = (item) => {
			return {
				firstLineText: `${item.fullName}`,
				secondLineText: `${item.organisation}`,
				dataKey: this.data.dataKey,
				dataValue: item.contactId
			};
		};
		this.searchInputTextField.filterDataMapping = (item, event) => {
			return item.contactId === event[this.data.dataKey];
		};
		this.searchInputTextField.searchInputMappingChange();
		this.searchInputTextField.onChange((event) => {
			this.loadCoachResult(event.value);
		});

		if (this.data?.value) {
			this.loadCoachResult(this.data?.value);
		}
	}
	loadCoachResult(resultDetails) {
		this.coachFinderSearchInputWrapper.classList.add(HIDDEN_CLASS);
		this.coachFinderSearchForm.classList.add(HIDDEN_CLASS);
		this.coachFinderTitle.classList.remove(HIDDEN_CLASS);
		this.coachFinderSearchResult.classList.remove(HIDDEN_CLASS);
		this.setupValueObject(resultDetails);
		this.coachFinderSearchResult.insertAdjacentHTML('beforeend', this.renderAutoSuggestResult(resultDetails));
		this.afterAutoSuggestResultRender();
	}
	setupValueObject(value) {
		this.value = {
			...this.data,
			value: {
				...value
			}
		};
		if (this.value) {
			this.dependentQuestion = this.value.dependentQuestion;
		}
	}
	afterAutoSuggestResultRender() {
		const suggestionAutoSuggestResult = SelectorEngine.findOne(
			'.lta-autosuggest-input-result',
			this.coachFinderSearchResult
		);
		const searchAgainButton = SelectorEngine.findOne('.lta-coach-search--again', suggestionAutoSuggestResult);

		EventHandler.on(searchAgainButton, CLICK_EVENT, () => {
			suggestionAutoSuggestResult.remove();
			this.coachFinderSearchInputWrapper.classList.remove(HIDDEN_CLASS);
			this.coachFinderTitle.classList.add(HIDDEN_CLASS);
			this.coachFinderSearchForm.classList.add(HIDDEN_CLASS);
			this.coachFinderSearchResult.classList.add(HIDDEN_CLASS);
		});
	}
	renderAutoSuggestResult(coachDetails) {
		return `<div class="lta-autosuggest-input-result">
					<div class="u-px-3 u-py-2 u-bg-background-blue u-rounded">
						<div class="lta-autosuggest-input-result_first-name u-h6 u-mb-1">${coachDetails.fullName}</div>
						<div class="u-body2 u-mb-2">
							<table>
								<tr class="u-mb-1">
									<td class="lta-coach-finder__value">Locations:</td>
									<td>${coachDetails.location}</td>
								</tr>
								<tr class="u-mb-1">
									<td class="lta-coach-finder__value">County:</td>
									<td>${coachDetails.county}</td>
								</tr>
								<tr>
									<td class="lta-coach-finder__value">Coach Code:</td>
									<td>${coachDetails.coachCode}</td>
								</tr>
							</table>
						</div>
						<button type="button" class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before lta-coach-search--again">
							<svg class="lta-icon js-lta-text-input--btn-icon u-mr-0" width="1.5em" height="1.5em" fill="currentColor" alt="search" aria-hidden="true">
								<use xlink:href="/static/images/icons/lta-icons.svg#search"></use>
							</svg>Search again
						</button>
					<div>
				</div>`;
	}
	renderInstructionLabel(instructionLabel) {
		return instructionLabel ? `<span class="lta-text-input__label-instruction">${instructionLabel}</span>` : '';
	}
	setupValidateObject() {
		this.formElementData = {
			element: this.searchInputFieldContainerElement,
			formElement: this.searchInputFieldElement,
			errorMessage: this.data.errorMessage,
			inputType: InputTypes.SELECTOR_INPUT,
			hasIcon: false
		};
	}
	validate() {
		this.searchInputTextField.validate();
		if (this.coachSearch) {
			this.coachSearch.validate();
		}
	}
}
export default CoachFinder;
